import { LoadingOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import type Asset from 'stores/Asset';
import { AssetFileType } from 'types/AssetFileType';

import DownloadFileButton from './DownloadFileButton';
import NavigateToFolderButton from './NavigateToFolderButton';
import RemoveFileButton from './RemoveFileButton';
import RemoveFolderButton from './RemoveFolderButton';
import UpdateFileButton from './UpdateFileButton';

const Container = styled.div`
  align-items: center;
  display: flex;
  gap: 7px;
`;

const LoadingIcon = styled(LoadingOutlined)`
  padding-right: 8px;
`;

const FileSizeLabel = styled.span``;

function FileButtons({ asset }: { asset: Asset }) {
  return (
    <>
      <FileSizeLabel>{asset.fileSizeString}</FileSizeLabel>
      <DownloadFileButton asset={asset} />
      <UpdateFileButton asset={asset} />
      <RemoveFileButton asset={asset} />
    </>
  );
}

function FolderButtons({ asset }: { asset: Asset }) {
  return (
    <>
      <NavigateToFolderButton asset={asset} />
      <RemoveFolderButton asset={asset} />
    </>
  );
}

export interface AssetRowButtonsProps {
  asset: Asset;
}

function AssetRowButtons({ asset }: AssetRowButtonsProps) {
  return (
    <Container>
      {asset.loading && <LoadingIcon />}
      {asset.data.type === AssetFileType.FOLDER ? (
        <FolderButtons asset={asset} />
      ) : (
        <FileButtons asset={asset} />
      )}
    </Container>
  );
}

export default observer(AssetRowButtons);
